import axios from "axios";
import { useEffect, useState } from "react";
import { getSender } from "../config/ChatLogics";
import ChatLoading from "./ChatLoading";
import GroupChatModal from "./Modals/GroupChatModal";
import { ChatState } from "../Context/ChatProvider";
import Addicon from "../images/Addicon";
import SponsoredChat from "./SponsoredChat";
import { extractTimeOderDate, getAuthConfig} from "../utils/functions";
import ConfirmModal from "./Modals/ConfirmModal/ConfirmModal";
import socket from "./../socketClient";
import {useHistory} from "react-router-dom/cjs/react-router-dom";

const MyChats = ({ fetchAgain }) => {
    const [loggedUser, setLoggedUser] = useState();
    const { selectedChat, setSelectedChat, user, chats, setChats, setOpenCreateGroupChat, showToast } = ChatState();
    const [isOpen, setIsOpen] = useState(false);
    //const [i, setI] = useState(null);  // Fur saveing index of the chat to delete
    const [chatToDelete, setChatToDelete] = useState({});
    const [loading, setLoading] = useState(false);
    const [scrollTopBeforeDeleteSingleChat, setScrollTopBeforeDeleteSingleChat] = useState(0);
    const [sponsoredChat, setSponsoredChat] = useState(true);
    const history = useHistory();
    const fetchChats = async () => {
        try {
            setLoading(true);
            const config = {
                headers: { Authorization: `Bearer ${user.token}`},
                withCredentials: true
            };
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/chat`, config);
            setChats(data);
        } catch (error) {
            showToast ('danger', 'Error Occured! Failed to Load the Chats.' );
            if (error.response?.status === 401) {
                history.push("/");
            }
        } finally {
            setLoading(false); 
        }
    };

    useEffect(() => {
        setLoggedUser(JSON.parse(localStorage.getItem("userInfo")));
        fetchChats();
        // Logic for updating chat list when a new message arrives
        const handleChatUpdate = (updateData) => {
            const { chatId, lastMessage, sender } = updateData;
            setChats(prevChats => {
                if (!prevChats) return [];
                const updatedChatList = prevChats.map(chat => {
                    if (chat?._id === chatId) {
                        return {
                            ...chat, 
                            latestMessage: { 
                                content: lastMessage,
                                sender: { name: sender, pic: '', _id: '' }, 
                                createdAt: new Date().toISOString() 
                            },
                            updatedAt: new Date().toISOString() 
                        };
                    }
                    return chat;
                });
                // 2. Logic to move the updated chat to the top
                const movedChat = updatedChatList.find(chat => chat?._id === chatId);
                const otherChats = updatedChatList.filter(chat => chat?._id !== chatId);
                // If the updated chat is selected, update it
                if (selectedChat && selectedChat._id === chatId) {
                    setSelectedChat(movedChat);
                }
                return [movedChat, ...otherChats]; 
            });
        };
        socket.on('chat list updated', handleChatUpdate);
        return () => {
            socket.off('chat list updated', handleChatUpdate);
        };
    }, [fetchAgain, setChats]);

    const onClickSpanFunction =(e, i)=> {
        //setI(i);
        setIsOpen(true);
        e.preventDefault();
        setChatToDelete(chats[i]);
    }
    const handleSaveScrollTop = (scrollTop) => {  //Positioning messages at the place of the deleted message
        setScrollTopBeforeDeleteSingleChat(scrollTop);
    };
    const handleClearScrollTop = () => {
        setScrollTopBeforeDeleteSingleChat(null);
    };
    const deleteChatHandler = async() => {
        if (chatToDelete.isGroupChat) {
           if (!(chatToDelete.groupAdmin._id === user._id)) {
                showToast ( 'warning', 'Only admin can add/remove/change groupchat!' );  
                return;
            }
        }
        handleSaveScrollTop(scrollTopBeforeDeleteSingleChat || 0);
        try {
            setLoading(true);
            const config = getAuthConfig(user.token);
            await axios.post(
                `${process.env.REACT_APP_API_URL}/api/chat/deletegroup`,
                {
                    chatId: chatToDelete._id
                },
                config
            );
            fetchChats();
            setChatToDelete({});
            handleClearScrollTop();
            showToast ( 'success', `Chat   ${chatToDelete.chatName} deleted successfully!` );
        } catch (error) {
            showToast ('danger', error.res || 'Failed to delete the chat.' );
        } finally {
            setLoading(false);
        }
    }
    const onClose =()=> {
        setIsOpen(false);
    }
    return (
        <div className='box31'  style={{display: `${!!selectedChat  ? 'none' : 'flex'}` }} >
            <div className=' myChats_header'>
                <span>My Chats</span>
                <GroupChatModal>
                    <button className='newChat ' type='button'  onClick={()=>setOpenCreateGroupChat(true)} >
                        <span className=' new_group_button'>New group chat</span>
                        <span className=' close_button'>
                            <Addicon className = '' focusable="false" aria-hidden="true" />
                        </span>
                    </button>
                </GroupChatModal>
                <ConfirmModal onClose={onClose} isOpen={isOpen} onConfirm={deleteChatHandler} content = {"Do you really want to delete the chat?"}  />
            </div>
            <div className='myChats'>
                { chats && chats.length === 0 ?  <div className="no_chats">You don't have any chats yet. Create one.</div> : null}
                {chats ? (
                    <div className='myChats-scroll'>
                        {sponsoredChat && <SponsoredChat setSponsoredChat={setSponsoredChat}/>}
                        {chats?.map((chat, i) => {
                            return <div className={` ${chat?.isGroupChat ? '' : 'noGroup'} ${selectedChat === chat ? "chat_item active" : "chat_item"}`}
                                onClick={() => setSelectedChat(chat)}
                                key={chat?._id} onContextMenu={(e) => onClickSpanFunction(e, i)}>
                                <div className= {`chat_item-image ${chat?.isGroupChat ? '' : 'noGroup'}`}>
                                    <img
                                        src={chat?.isGroupChat ? chat.groupAdmin.pic : chat?.users[0].name == user.name ? chat?.users[1].pic : chat?.users[0].pic}
                                        alt='avatar'  />
                                    <div className='chat_item-image-images'>
                                        {chat?.isGroupChat && chat.users.filter(user => user.name !== chat.groupAdmin.name).map((user, i) => (
                                            <img    key={user._id || i} 
                                                    style={{ left: `${-i * 10}px` }} 
                                                    className='chat_item-image-images-image' 
                                                    src={user.pic} 
                                                    alt="F"
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div className='chat_item-text'>
                                    <div className='chat_item-name_date'>
                                        <p className='chat_item-name'>
                                            {!chat?.isGroupChat
                                                ? getSender(loggedUser, chat?.users)
                                                : chat?.chatName}
                                        </p>
                                        <div className='chat_item-date_time'>
                                           <span>{chat?.updatedAt ? extractTimeOderDate(chat.updatedAt) : ""}</span>
                                        </div>
                                    </div>
                                    <div className='chat_item-lastMessage'>
                                        {chat?.latestMessage && (
                                            <p className=' text lastMessage'>
                                                <b>{chat?.latestMessage.sender.name} : </b>
                                                {chat?.latestMessage.content.length > 50
                                                    ? chat.latestMessage.content.substring(0, 51) + "..."
                                                    : chat.latestMessage.content}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                ) : (
                    <div className='myChats-loading' >
                        <ChatLoading />
                    </div>
                )}
            </div>
        </div>
    );
};

export default MyChats;
